import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class FormSigningRequestStore extends LocalModel {
    constructor() {
        super('formSigningRequest', {
            namePlural: 'formSigningRequests',
            namePluralReal: 'formsigningrequests',
            sort: '-requestedDate',
            limit: 100,
            api: {
                search: { url: '/api/formsigningrequests/', params: { limit: 100 } },
                load: { url: '/api/formsigningrequests/', params: {} },
                save: { url: '/api/formsigningrequests/', params: {} },
            },
        });
    }

    @observable formSigningRequests = [];

    @observable formSigningRequest = {};

    @observable unread = 0;

    @action
    clearAll() {
        this.formSigningRequests = [];
        this.formSigningRequest = {};
    }

    async createRequest({
        formType, offset = 0, note = '', customer, place, date,
    }) {
        const response = await util.fetchApi(`/api/formsigningrequests/?offset=${offset}`, { method: 'POST' }, {
            formType, note, customer, place, date,
        });
        if (response.status === 201) {
            await this.load();
        }
        return response;
    }

    async approve(id) {
        const response = await util.fetchApi(`/api/formsigningrequests/${id}/approve`, { method: 'POST' }, {});
        if (response.status === 200) {
            await this.load();
        }
        return response;
    }

    async reject(id, reason) {
        const response = await util.fetchApi(`/api/formsigningrequests/${id}/reject`, { method: 'POST' }, { reason });
        if (response.status === 200) {
            await this.load();
        }
        return response;
    }

    async deleteRequest(id) {
        const response = await util.fetchApi(`/api/formsigningrequests/${id}`, { method: 'DELETE' });
        if (response.status === 200) {
            await this.load();
        }
        return response;
    }

    async getUnreadCount() {
        const response = await util.fetchApi('/api/formsigningrequests/unread', { method: 'GET' });
        if (response.status === 200) {
            this.updateKeyValue('unread', response.data || 0);
        }
        return response;
    }
}

const store = new FormSigningRequestStore();
export default store;
